import MultiSelectCheckmarkBadgeIcon from "@homeinstead/icons/MultiSelectCheckmarkBadge";
import { cn } from "@homeinstead/ui";

function SelectedMultiSelectCheckmark() {
  return (
    <div
      aria-hidden="true"
      className={cn(
        "motion-safe:animate-multiselect-checkmark-enter",
        "motion-reduce:animate-none",
      )}
    >
      <MultiSelectCheckmarkBadgeIcon
        className={cn(
          "size-6",
          "motion-safe:[&_path]:animate-selection-checkmark-draw",
          "motion-reduce:[&_path]:animate-none",
        )}
        data-testid="selected-multiselect-checkmark"
      />
    </div>
  );
}

export { SelectedMultiSelectCheckmark };
